const ENTITY_TYPES = Object.freeze({
  BUBBLE: 'bubble',
  QUESTION: 'question',
  RAT_ROW: 'ratRow',
});

const snapshots = new Map();

const buildKey = (entityType, id) => `${entityType}:${id}`;

const getEntityId = (entity) => {
  if (!entity || typeof entity !== 'object') return null;
  return entity._id ?? entity.id ?? null;
};

const cloneSnapshot = (entity) => {
  if (!entity || typeof entity !== 'object') return null;
  if (typeof structuredClone === 'function') {
    return structuredClone(entity);
  }
  return JSON.parse(JSON.stringify(entity));
};

export function setSnapshot(entityType, entity) {
  const id = getEntityId(entity);
  if (!id) return;
  snapshots.set(buildKey(entityType, id), cloneSnapshot(entity));
}

export function setSnapshots(entityType, entities) {
  if (!Array.isArray(entities)) return;
  entities.forEach((e) => setSnapshot(entityType, e));
}

export function getSnapshot(entityType, id) {
  if (!id) return null;
  return snapshots.get(buildKey(entityType, id)) || null;
}

export function removeSnapshot(entityType, id) {
  if (!id) return;
  snapshots.delete(buildKey(entityType, id));
}

export function clearSnapshots(entityType) {
  if (!entityType) {
    snapshots.clear();
    return;
  }
  const prefix = `${entityType}:`;
  Array.from(snapshots.keys()).forEach((key) => {
    if (key.startsWith(prefix)) snapshots.delete(key);
  });
}

export function attachBase(entityType, payload) {
  const id = getEntityId(payload);
  const snap = getSnapshot(entityType, id);
  if (!snap) return payload;
  return { ...payload, __base: snap };
}

export { ENTITY_TYPES };
